<template>
  <div class="body" style="margin-top: 1rem">
    <div class="body_left">
      <div class="bl_t_time">
        <div v-if="form.state == 1">
          <span class="blt_t_state1">己发布</span>
          <span>{{ form.time }}后结束</span>
        </div>
        <!-- <div v-if="form.state == 2">
          <span class="blt_t_state1">待付款</span>
            <span>{{ form.time }}后结束</span>
          </div> -->
        <div v-if="form.state == 3">
          <span class="blt_t_state1">已付款</span>
          <span>{{ form.time }}后结束</span>
        </div>
        <div v-if="form.state == 4">
          <span class="blt_t_state1">进行中</span>
          <span class="blt_t_date1">{{ form.time }}后结束</span>
        </div>
        <div v-if="form.state == 2">
          <span class="blt_t_state2">待付款</span>
          <span>{{ form.time }}后结束</span>
          <!-- <span class="blt_t_date2"> 创作人通过签单达成合作</span> -->
        </div>
        <!-- <div v-if="form.state == 7">
          <span class="blt_t_state3">已评价</span>
          <span class="blt_t_date3">{{ form.time }}后结束</span>
        </div> -->

        <span class="bltt_time">{{
          com_date.com_date.timestamp_string(form.createTime, true, "-", ":")
        }}发布</span>
      </div>
      <div class="bl_t_title">
        <div class="bl_t_title_l">
          <span>{{ form.projectName }}</span>
          <div>
            <span>工作地点：{{ form.workPlace }}</span>
            <span>交付时间：
              {{
                com_date.com_date.timestamp_string(
                  form.deliveryTime,
                  false,
                  "-",
                  ":"
                )
              }}
            </span>
            <span>技能类型：{{ form.skillType }}</span>
          </div>
        </div>
        <div class="bl_t_title_r">
          <span class="bl_t_title_r_title">需求预算</span>
          <span class="bl_t_title_r_number">￥{{ (form.price / 1).toFixed(2) }}</span>
        </div>
      </div>
      <div class="bl_t_describe">
        <p>需求描述</p>
        <div class="bl_t_describe_list">
          {{ form.projectDescription }}
          <!-- <p>
            1、甲方仅需杭州当地创作人，异地勿报名，甲方提供视频，有参考样片，有截图，创作人提供调色服务
          </p>
          <p>2、总时长4分钟，分场景四段剧情片，成片交付时间26日下午5点之前</p> -->
        </div>
        <div v-if="form.state == 1">
          <div v-if="!myMemberIdShow">{{ "" }}</div>
          <!-- {{ isLjbm }}{{ myMemberIdShow }} -->
          <button v-else @click="open" :style="{ background: isLjbm ? '#c1c1c1' : '#C01A26' }" :disabled="isLjbm"
            class="buttonc">
            立即报名
          </button>
        </div>
        <div v-else-if="form.state == 2"></div>
        <div v-else class="writtenStyle">
          <img src="../../assets/module_dqd.png" />
          <div>
            <!-- <span v-if="form.state == 2" class="writtenS_t_1">未付款</span> -->
            <p v-if="form.state == 3 || form.state == 4" class="writtenS_">
              <span class="writtenS_t_1">担保中</span>
              <span class="writtenS_n_1">￥{{ (form.price / 1).toFixed(2) }}</span>
            </p>
            <p v-else class="writtenS_">
              <span class="writtenS_t_2">已结算</span>
              <span class="writtenS_n_2">￥{{ (form.price / 1).toFixed(2) }}</span>
            </p>
            <p class="writtenS_t_title">
              {{ form.createUserName }} 资金通过平台结算，交易有保障
            </p>
          </div>
        </div>
      </div>
      <div class="bl_t_data">
        <div class="bl_t_data_hzczr">
          <p class="bl_t_data_hzczrP">合作创作人</p>
          <div class="bltd_hzczr_list">
            <!-- 空数据 -->
            <div class="kong" v-if="!list1.length">
              <img src="../../assets/module_kong.png" />
              <p>暂无合作创作人</p>
            </div>
            <el-col :span="8" v-for="index in list1" :key="index">
              <moduleHotComposerQd @click="Details(1, index.userId)" :item="index"></moduleHotComposerQd>
            </el-col>
            <!-- 非空数据 -->
          </div>
        </div>
        <div v-if="form.state == 5" class="bl_t_data_hzczr">
          <div class="bl_t_data_hzczrP" style="margin-bottom: 0.4rem">
            合作评价
          </div>
          <div class="bltd_hzczr_list">
            <!-- 空数据 -->
            <div class="kong" v-if="!EvaluationContentList.length">
              <img src="../../assets/module_kong.png" />
              <p>暂无评价</p>
            </div>
            <!-- 非空数据 -->
            <div class="leaveMessageList" v-else v-for="(item, index) in EvaluationContentList" :key="index">
              <img class="tx_img1" :src="item.avatar ? item.avatar : require('@/assets/logo.png')" />
              <div>
                <div class="LML_user">
                  <!-- <span class="LML_user_name">王**</span> -->
                  <span class="LML_user_name">{{
                    item.evaluate_user_name.slice(0, 1) + "*".repeat(2)
                  }}</span>

                  <span class="LML_user_SF">{{ item.BothParties }}</span>
                  <span class="LML_user_time">{{
                    com_date.com_date.timestamp_string(
                      item.evaluate_time,
                      true,
                      "-",
                      ":"
                    )
                  }}</span>
                </div>
                <span class="LML_message">{{ item.evaluate_content }}</span>
              </div>
            </div>
          </div>
        </div>
        <div>
          <div class="bl_t_data_bmczr">
            <span class="bl_t_data_hzczrP">报名创作人</span>
            <!-- <div>
              <span>选择1</span>
              <span>选择1</span>
            </div> -->
          </div>
          <div class="bl_t_data_bmczr_list">
            <el-row :gutter="20">
              <div class="kong" v-if="!list.length">
                <img src="../../assets/module_kong.png" />
                <p>暂无报名创作人</p>
              </div>
              <el-col v-else :span="8" v-for="index in list" :key="index">
                <moduleHotComposerQd @click="Details(1, index.userId)" :item="index"></moduleHotComposerQd>
              </el-col>
            </el-row>
          </div>
        </div>
      </div>
    </div>
    <div class="body_right">
      <div class="br_top">
        <div class="br_top_l">
          <p class="brt_number">{{ form.views ? form.views : 0 }}</p>
          <p class="brt_title">浏览人数</p>
        </div>
        <div class="br_top_r">
          <p class="brt_number">{{ form.total ? form.total : 0 }}</p>
          <p class="brt_title">已报名</p>
        </div>
      </div>

      <div class="br_main" @click="Details(1, form.createUserId)">
        <!-- <img src="../../assets/logo.png" /> -->
        <img :src="form.avatar ? form.avatar : require('@/assets/logo.png')" alt="" class="tx_img" />
        <div class="br_main_user">
          <span style="margin-right: 0.05rem">{{ form.nickName }}</span>
          <!-- <img src="@/assets/publick_huiyuan2.png" /> -->
          <img v-if="form.realStatus == 2" src="@/assets/Frame1.png" title="实名认证" @click="CertificationCenter" />

          <img v-if="form.enterpriseStatus == 2" src="@/assets/Frame2.png" title="企业认证" @click="CertificationCenter" />
          <img v-if="form.unionStatus == 2" src="@/assets/Frame3.png" title="联盟认证" @click="CertificationCenter" />
        </div>
        <view class="" v-if="form.professionalStatus == 2"
          style="display: flex; justify-content: center; padding: 0.1rem 0">
          <!-- <view c="wVC_list_l_T_B_rz"> 标识山西认证导演 </view> -->

          <div class="wVC_list_l_T_B_rz">
            <img src="@/assets/bvlv_blue.png" />
            标识山西认证{{ form.profess }}
          </div>
        </view>
        <div class="br_top" style="
            border: 0rem solid #fff;
            border-bottom: 0.01rem solid #e5e6eb;
            border-radius: 0rem;
          ">
          <div class="br_top_l">
            <p class="brt_number">{{ form.publishCount }}</p>
            <p class="brt_title">已发布需求</p>
          </div>
          <div class="br_top_r">
            <p class="brt_number">{{ form.count }}</p>
            <p class="brt_title">合作中</p>
          </div>
        </div>
        <div class="br_main_location">
          <img src="../../assets/bvlv_zb.png" />{{ form.realDAddress }}
        </div>
        <el-button type="primary" size="small" class="br_main_btn">需求方</el-button>
      </div>
    </div>
  </div>
</template>

<script setup>
import { ref } from "vue";
import { useRoute, useRouter } from "vue-router";
import moduleHotComposerQd from "../../components/moduleHotComposerQd.vue";
const router = useRoute();
const route = useRouter();
const writtenChecked = ref(1);
import com_date from "@/assets/js/common.js";
import { ElMessage, ElMessageBox } from "element-plus";
import { Axios } from "@/assets/js/ls_com_axios.js";
const form = ref({});
const list = ref([]);
const isLjbm = ref(false);
const list1 = ref([]);
document.title = "标识山西-找业务";
const Details = (index, row) => {
  route.push({
    path: "/ShadowComposerHomepage",
    query: { id: row },
  });
};
// 报名
const open = () => {
  ElMessageBox.confirm("系统提示是否确认报名?", "系统提示", {
    confirmButtonText: "确认",
    cancelButtonText: "取消",
    type: "warning",
  })
    .then(() => {
      Axios(
        "post",
        `/material/material/need/signUp?needId=${router.query.id}`,
        "",
        false,
        function (res) {
          if (res.data.code == 200) {
            ElMessage({
              type: "success",
              message: "报名成功",
            });
            signUpInfo();
          }
        }
      );
    })
    .catch(() => {
      ElMessage({
        type: "info",
        message: "已取消",
      });
    });
};
const EvaluationContentList = ref([]);
// 详情
Axios(
  "get",
  `/material/material/need/${router.query.id}`,
  "",
  false,
  function (res) {
    if (res.data.code == 200) {
      let deliveryTime = res.data.data.info.deliveryTime; // 假设为一个时间戳
      let currentTime = new Date().getTime();

      let timeDiff = deliveryTime - currentTime; // 计算时间差
      let seconds = Math.floor(timeDiff / 1000);
      let minutes = Math.floor(seconds / 60);
      let hours = Math.floor(minutes / 60);
      let days = Math.floor(hours / 24);
      let formattedDays = String(days).padStart(2, "0"); // 格式化天数
      let formattedDays1 = String(days); // 格式化天数

      let date = new Date(timeDiff * 1000);
      let decimalDays = date.getHours();
      // let decimalDays = (
      //   remainingHours / 24 +
      //   remainingMinutes / (24 * 60) +
      //   remainingSeconds / (24 * 60 * 60)
      // ).toFixed(1); // 小数天数
      let { log } = console;
      formattedDays !== "00"
        ? formattedDays / 1 > 0
          ? (res.data.data.info.time = formattedDays + "" + "天")
          : (res.data.data.info.time = "已过期")
        : (res.data.data.info.time = decimalDays + "" + "小时");
      log(formattedDays, formattedDays1, decimalDays);
      document.title += "-" + res.data.data.info.projectName;
      form.value = res.data.data.info;
      form.value.total = 0;
      myMemberIdShow.value = true;
      // let obj = JSON.parse(localStorage.getItem("userList"));
      if (JSON.parse(localStorage.getItem("userList"))) {
        if (
          JSON.parse(localStorage.getItem("userList")).memberId ==
          res.data.data.info.createUserId
        ) {
          myMemberIdShow.value = false;
        }
      }

      form.value.count = res.data.data.count;
      form.value.publishCount = res.data.data.publishCount;
      if (res.data.data.info.state == 5) {
        Axios(
          "post",
          "/material//material/need/listEvaluate",
          {
            pageIndex: 1,
            pageSize: 20,

            condition: {
              needId: res.data.data.info.id,
            },
          },
          false,
          function (res) {
            if (res.data.code == 200) {
              if (res.data.data.records && res.data.data.records.length > 0) {
                res.data.data.records.forEach((e) => {
                  if (JSON.parse(localStorage.getItem("userList"))) {
                    if (
                      (e.evaluate_user_id ===
                        JSON.parse(localStorage.getItem("userList"))
                          .memberId) ===
                      form.value.createUserId
                    ) {
                      e.BothParties = "甲方";
                    } else {
                      e.BothParties = "乙方";
                    }
                  }
                });
              }
              EvaluationContentList.value = res.data.data.records;

              // EvaluationContentObj.value = res.data.data.records[0];
            } else {
              console.log(res);
            }
          }
        );
      }
      signUpInfo();
    } else {
      ElMessage.error(res.data.message);
    }
  }
);
// 报名详情
let params = {
  pageIndex: 1,
  pageSize: 10,
  needId: router.query.id,
};
const myMemberIdShow = ref(true);
const signUpInfo = () => {
  Axios(
    "GET",
    "/material/material/need/signUpInfo",
    params,
    false,
    function (res) {
      if (res.data.code == 200) {
        list.value = res.data.data.records.filter((item) => item.state != 3);

        list1.value = res.data.data.records.filter((item) => item.state > 0);
        let linArr = [];
        if (JSON.parse(localStorage.getItem("userList"))) {
          linArr = res.data.data.records.filter(
            (item) =>
              item.userId ==
              JSON.parse(localStorage.getItem("userList")).memberId
          );
        }

        if (linArr.length != 0 || list1.value.length) {
          isLjbm.value = true;
        } else {
          isLjbm.value = false;
        }
        // list1.value = res.data.data.records.filter(
        //   (item) => item.state == 1 || item.state == 2 || item.state == 6
        // );
        // console.log("list1", list1.value);
        form.value.total = res.data.data.total;
      } else {
        console.log(res);
      }
    }
  );
};
const CertificationCenter = (item) => {
  route.push({
    path: "/AuthenTicationHome",
  });
};
</script>
<style scoped>
.body {
  width: 12.8rem;
  margin: 0 auto;
  display: flex;
  margin-top: 0.3rem;
}

.body_left {
  flex-grow: 1;
  width: calc(100% - 4.2rem);
}

.body_right {
  width: 3.8rem;
  margin-left: 0.4rem;
}

.br_top,
.br_main {
  border-radius: 0.12rem;
  border: 0.01rem solid #e5e6eb;
  padding: 0.24rem 0;
  display: flex;
  margin-bottom: 0.2rem;
}

.br_main {
  display: block;
  position: relative;
}

.tx_img {
  width: 0.8rem;
  height: 0.8rem;
  border: 0.08rem solid #ffffff;
  display: block;
  margin: 0 auto;
  border-radius: 50%;
}

.tx_img1 {
  width: 1rem;
  height: 1rem;
  border: 0.08rem solid #ffffff;
  border-radius: 50%;
  display: block;
}

.br_top_l {
  width: 50%;
  border-right: 0.01rem solid #e5e6eb;
}

.br_top_r {
  flex-grow: 1;
}

.brt_number {
  font-size: 0.2rem;
  color: #000000;
  text-align: center;
  margin-bottom: 0.08rem;
}

.brt_title {
  text-align: center;
  color: #86909c;
  font-size: 0.12rem;
}

.br_main>img {
  width: 0.8rem;
  display: block;
  margin: 0 auto;
  margin-bottom: 0.16rem;
}

.br_main_user {
  display: flex;
  color: #000000;
  font-size: 0.14rem;
  justify-content: center;
  align-items: center;
}

.br_main_user>img {
  height: 0.16rem;
}

.wVC_list_l_T_B_rz {
  color: #015243;
  background: #e1fefc;
  border-radius: 0.1rem;
  font-size: 0.12rem;
  padding: 0.02rem 0.16rem 0.02rem 0.04rem;
  display: flex;
  align-items: center;
}

.wVC_list_l_T_B_rz>img {
  width: 0.13rem;
  margin-right: 0.09rem;
}

.br_main_location {
  color: #333333;
  font-size: 0.14rem;
}

.br_main_location>img {
  width: 0.13rem;
  margin-right: 0.06rem;
  margin-left: 0.17rem;
}

.bl_t_time {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 0.24rem;
}

.blt_t_state1 {
  background: rgba(63, 164, 237, 0.2);
  border-radius: 0.04rem;
  margin-right: 0.12rem;
  padding: 0.06rem;
  color: #3fa4ed;
  font-size: 0.14rem;
}

.blt_t_state2 {
  background: rgba(255, 138, 82, 0.2);
  border-radius: 0.04rem;
  margin-right: 0.12rem;
  padding: 0.06rem;
  color: #ff8a52;
  font-size: 0.14rem;
}

.blt_t_state3 {
  background: rgba(75, 193, 133, 0.2);
  border-radius: 0.04rem;
  margin-right: 0.12rem;
  padding: 0.06rem;
  color: #4bc185;
  font-size: 0.14rem;
}

.blt_t_date1 {
  color: #c01a26;
  font-size: 0.12rem;
}

.blt_t_date2 {
  color: #c01a26;
  font-size: 0.12rem;
}

.blt_t_date3 {
  color: #4bc185;
  font-size: 0.12rem;
}

.bltt_time {
  color: #333333;
  font-size: 0.12rem;
}

.bl_t_title {
  display: flex;
  justify-content: space-between;
  margin-bottom: 0.23rem;
}

.bl_t_title_l>span {
  font-size: 0.2rem;
  color: #333333;
  margin-bottom: 0.12rem;
  display: block;
}

.bl_t_title_l>div>span {
  color: #333333;
  font-size: 0.14rem;
  margin-right: 0.2rem;
}

.bl_t_title_r {
  display: flex;
  flex-direction: column;
  align-items: end;
}

.bl_t_title_r_title {
  color: #86909c;
  font-size: 0.14rem;
}

.bl_t_title_r_number {
  font-size: 0.24rem;
  color: #c01a26;
}

.bl_t_describe>p {
  color: #86909c;
  font-size: 0.14rem;
}

.bl_t_describe_list {
  margin-top: 0.12rem;
}

.bl_t_describe_list>p {
  font-size: 0.14rem;
  color: #333333;
}

.buttonc {
  background: #c01a26;
  border-radius: 0.08rem 0.08rem 0.08rem 0.08rem;
  padding: 0.12rem 1.06rem;
  color: #ffffff;
  font-size: 0.14rem;
  border: 0rem solid #fff;
  margin-top: 0.24rem;
  margin-bottom: 0.3rem;
}

.bl_t_data {
  border-top: 0.01rem solid #e5e6eb;
  padding: 0.3rem 0;
  width: 100%;
}

.bl_t_data_hzczrP {
  color: #333333;
  font-size: 0.24rem;
}

.bltd_hzczr_list {
  /* min-height: 3.43rem; */
}

.kong {
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  flex-direction: column;
}

.kong>img {
  width: 2.4rem;
  margin: 0 auto;
}

.kong>p {
  color: #86909c;
  font-size: 0.14rem;
}

.writtenStyle {
  border-radius: 0.12rem 0.12rem 0.12rem 0.12rem;
  background: #e1fefc;
  padding: 0.21rem 0.24rem;
  margin-top: 0.24rem;
  display: flex;
}

.writtenStyle>div {
  display: flex;
  flex-direction: column;
  justify-content: center;
}

.writtenStyle>img {
  width: 0.6rem;
  margin-right: 0.12rem;
}

.writtenS_t_1 {
  color: #015243;
  font-size: 0.14rem;
  margin-right: 0.08rem;
}

.writtenS_n_1 {
  color: #c01a26;
  font-size: 0.14rem;
}

.writtenS_t_2 {
  color: #015243;
  font-size: 0.14rem;
  margin-right: 0.08rem;
}

.writtenS_n_2 {
  color: #4bc185;
  font-size: 0.14rem;
}

.writtenS_t_title {
  margin-top: 0.11rem;
  color: #015243;
  font-size: 0.14rem;
}

.leaveMessageList {
  display: flex;
  justify-content: flex-start;
  align-items: center;
  margin-bottom: 0.4rem;
}

.leaveMessageList>img {
  width: 0.5rem;
  height: 0.5rem;
  border: 0.08rem solid #ffffff;
  border-radius: 50%;
  display: block;
}

.LML_user {
  margin-bottom: 0.08rem;
}

.LML_user_name {
  font-size: 0.14rem;
  color: #000000;
  margin-right: 0.08rem;
}

.LML_user_SF {
  border-radius: 0.04rem 0.04rem 0.04rem 0.04rem;
  background: rgba(134, 144, 156, 0.2);
  color: #86909c;
  font-size: 0.1rem;
  padding: 0.04rem;
  margin-right: 0.08rem;
}

.LML_user_time {
  color: #86909c;
  font-size: 0.14rem;
}

.LML_message {
  font-size: 0.14rem;
  color: #000000;
}

.br_main_btn {
  position: absolute;
  top: 20px;
  right: 20px;
  padding: 0.1rem;
}

.br_main_btn>img {
  width: 0.2rem;
  height: 0.2rem;
}
</style>
